<lib-cidaas-hosted-page-footer [imprintUri]="imprintUri" [tosUri]="tosUri" [policyUri]="policyUri" *ngIf="requestId">
</lib-cidaas-hosted-page-footer>